export default __webpack_public_path__ + "static/media/Outfit-Light.e7939137.woff";